import { render, staticRenderFns } from "./TicketTagEdit.vue?vue&type=template&id=30bbe913&scoped=true"
import script from "./TicketTagEdit.vue?vue&type=script&lang=js"
export * from "./TicketTagEdit.vue?vue&type=script&lang=js"
import style0 from "./TicketTagEdit.vue?vue&type=style&index=0&id=30bbe913&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbe913",
  null
  
)

export default component.exports